import React from "react";

import { ListItem } from "react-md";
import NavigatorListItemAvatar from "./NavigatorListItemAvatar";

const NavigatorListItem = ({
  step,
  currentRegistration,
  primaryText,
  secondaryText,
  incompleteText,
  threeLines,
  onClick
}) => {
  let status = "incomplete";

  if (currentRegistration) {
    if (currentRegistration.step.split("/")[0] === step.split("/")[0]) {
      status = "active";
    } else if (
      currentRegistration.completedSteps.includes(step.split("/")[0])
    ) {
      status = "complete";
    }
  }

  return (
    <ListItem
      primaryText={
        status !== "complete" && incompleteText ? incompleteText : primaryText
      }
      secondaryText={status === "complete" ? secondaryText : null}
      leftAvatar={<NavigatorListItemAvatar status={status} />}
      disabled={status === "incomplete"}
      threeLines={status === "complete" && threeLines}
      onClick={() => onClick({ step: step })}
    />
  );
};

export default NavigatorListItem;



// WEBPACK FOOTER //
// ./src/registration/components/RegistrationNavigator/NavigatorListItem.jsx